<template>
  <div class="modal-out">
    <div class="modal">
      <div class="modal-header">
        <div style="padding: 6px;">编辑</div>
        <button type="button" class="btn-close" @click="closeSelf">X</button>
      </div>
      <div class="modal-body">

        <el-row class="row">
          <el-col :span="12" class="item">
            <div class="label">登录账号</div>
            <el-input v-model="edit_loginName" placeholder="请输入登录账号" disabled></el-input>
          </el-col>
          <el-col :span="12" class="item">
            <div class="label">选择角色</div>
            <el-select v-model="edit_roleCode" placeholder="选择角色" @change="changeRole" style="width:100%">
              <el-option v-for="item in roleList" :key="item.roleCode" :label="item.name" :value="item.roleCode"></el-option>
            </el-select>
          </el-col>

        </el-row>

        <el-row class="row">
          <el-col :span="12" class="item">
            <div class="label">姓名</div>
            <el-input v-model="edit_realName" placeholder="请输入姓名"></el-input>
          </el-col>
          <el-col :span="12" class="item">
            <div class="label">手机</div>
            <el-input v-model="edit_phone" placeholder="请输入手机"></el-input>
          </el-col>
        </el-row>

        <el-row class="row">
          <el-col :span="12" class="item">
            <div class="label">职工状态</div>
            <el-select v-model="edit_status" placeholder="选择状态" @change="changeStatus" style="width: 100%">
              <el-option
                  v-for="item in status2"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
              </el-option>
            </el-select>
          </el-col>

        </el-row>
      </div>
      <div class="modal-footer">
        <el-button :loading="loading"  type="primary" @click.native="confirm">确认</el-button>
      </div>
    </div>

  </div>
</template>


<script>

import {getStaffCode} from "@/utils/auth";
import {timeStr} from "@/common/times";
import {hex_md5} from "@/common/Base64MD5";


export default {
  name: 'Edit',
  props: [],
  data() {
    return {

      loading: false,

      edit_loginName:'',
      edit_realName:'',
      edit_roleCode:'',
      edit_phone:'',
      edit_staffCode:'',
      edit_governmentCode:'',

      arr:[],


      roleList:[],


      status2: [{
        value: 0,
        label: '默认'
      }, {
        value: 1,
        label: '正常'
      },
        {
          value: 2,
          label: '被禁用'
        }

      ],
      edit_status: 0,


    }
  },
  components:{

  },
  methods: {
    init(row){

      this.edit_loginName = row.loginName;
      this.edit_realName = row.realName;
      this.edit_roleCode = row.roleCode;
      this.edit_phone = row.phone;
      this.edit_status = row.status;
      this.edit_staffCode = row.staffCode;
      this.edit_governmentCode = row.governmentCode;

      this.getRoleList();

    },

    closeSelf() {
      this.$emit("closeEdit");
    },

    confirm(){

      if(this.loading){
        return;
      }else{
        this.loading = true;
      }


      if(this.edit_loginName == ''){
        this.$message('请输入用户名');
        this.loading = false;
        return;
      }
      if(this.edit_password == ''){
        this.$message('请输入密码');
        this.loading = false;
        return;
      }
      if(this.edit_realName == ''){
        this.$message('请添加用户名');
        this.loading = false;
        return;
      }
      if(this.edit_phone == ''){
        this.$message('请添加手机号');
        this.loading = false;
        return;
      }

      this.$axios({
        method: 'post',
        url: this.$shopUrl+'Staff/EditGov11',
        data: {
          timeStr:timeStr,
          sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          staffCode: getStaffCode(),

          loginName: this.edit_loginName,
          realName:this.edit_realName,
          roleCode:this.edit_roleCode,
          phone:this.edit_phone,
          status:this.edit_status,
          governmentCode:this.edit_governmentCode,

          staffCode2:this.edit_staffCode,

        }
      }).then( (response)=> {
        this.loading = false;
        if(response.data.error == 0){
          this.$emit("closeEdit");
          this.$emit("getList");
        }else{
          this.$message(response.data.Message);
        }

      }).catch(function (error) {
        console.log(error);
      });

    },


    getRoleList(){
      this.$axios({
        method: 'post',
        url: this.$shopUrl+'Role/ListForAuto',
        data: {
          timeStr:timeStr,
          sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          staffCode: getStaffCode(),
        }
      }).then( (response)=> {
        if(response.data.error == 0){
          this.roleList = response.data.data;
        }else if(response.data.error == 1){
          this.$message(response.data.message);
        }else{
          console.log(response.data.message);
        }
      }).catch(function (error) {
        console.log(error);
      });
    },


  }
}
</script>


<style>

</style>
